import { render, staticRenderFns } from "./GreySalviLogo.vue?vue&type=template&id=ef598484&scoped=true&"
var script = {}
import style0 from "./GreySalviLogo.vue?vue&type=style&index=0&id=ef598484&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef598484",
  null
  
)

export default component.exports